// Forbidden Commands - 禁地指令
import { BaseCommand } from '../command-parser/BaseCommand.js';

// 上移指令
class UpCommand extends BaseCommand {
  constructor(commandManager) {
    super('up', null, '向上移动', true, commandManager);
  }

  isAvailable() {
    return this.commandManager.stateManager.isInForbiddenMap();
  }

  getUnavailableMessage() {
    return '此指令只能在禁地中使用。';
  }

  execute(arg) {
    return this.commandManager.forbiddenManager.movePlayer(0, -1);
  }
}

// 下移指令
class DownCommand extends BaseCommand {
  constructor(commandManager) {
    super('down', null, '向下移动', true, commandManager);
    this.commandManager = commandManager;
  }

  isAvailable() {
    return this.commandManager.stateManager.isInForbiddenMap();
  }

  getUnavailableMessage() {
    return '此指令只能在禁地中使用。';
  }

  execute(arg) {
    return this.commandManager.forbiddenManager.movePlayer(0, 1);
  }
}

// 左移指令
class LeftCommand extends BaseCommand {
  constructor(commandManager) {
    super('left', null, '向左移动', true, commandManager);
    this.commandManager = commandManager;
  }

  isAvailable() {
    return this.commandManager.stateManager.isInForbiddenMap();
  }

  getUnavailableMessage() {
    return '此指令只能在禁地中使用。';
  }

  execute(arg) {
    return this.commandManager.forbiddenManager.movePlayer(-1, 0);
  }
}

// 右移指令
class RightCommand extends BaseCommand {
  constructor(commandManager) {
    super('right', null, '向右移动', true, commandManager);
    this.commandManager = commandManager;
  }

  isAvailable() {
    return this.commandManager.stateManager.isInForbiddenMap();
  }

  getUnavailableMessage() {
    return '此指令只能在禁地中使用。';
  }

  execute(arg) {
    return this.commandManager.forbiddenManager.movePlayer(1, 0);
  }
}

// 扫描指令
class ScanCommand extends BaseCommand {
  constructor(commandManager) {
    super('scan', null, '神识扫描周围区域', true, commandManager);
    this.commandManager = commandManager;
  }

  isAvailable() {
    return this.commandManager.stateManager.isInForbiddenMap();
  }

  getUnavailableMessage() {
    return '此指令只能在禁地中使用。';
  }

  execute(arg) {
    return this.commandManager.forbiddenManager.scanArea();
  }
}

// 退出禁地指令
class ExitCommand extends BaseCommand {
  constructor(commandManager) {
    super('exit', null, '退出禁地', true, commandManager);
    this.commandManager = commandManager;
  }

  isAvailable() {
    return this.commandManager.stateManager.isInForbiddenMap();
  }

  getUnavailableMessage() {
    return '此指令只能在禁地中使用。';
  }

  execute(arg) {
    return this.commandManager.forbiddenManager.exitMap();
  }
}

// 禁地帮助指令
class ForbiddenHelpCommand extends BaseCommand {
  constructor(commandManager) {
    super('forbidden_help', null, '禁地模式帮助', false, commandManager);
    this.commandManager = commandManager;
  }

  isAvailable() {
    return this.commandManager.stateManager.isInForbiddenMap();
  }

  getUnavailableMessage() {
    return '此指令只能在禁地中使用。';
  }

  execute(arg) {
    return [
      '禁地模式可用命令：',
      'up - 向上移动',
      'down - 向下移动',
      'left - 向左移动',
      'right - 向右移动',
      'scan - 神识扫描（查看周围安全区域）',
      'exit - 退出禁地',
      'status - 查看状态',
      'help - 查看帮助'
    ];
  }
}

// 注册禁地指令的函数
export function registerForbiddenCommands(commandManager) {
  commandManager.registerCommand(new UpCommand(commandManager));
  commandManager.registerCommand(new DownCommand(commandManager));
  commandManager.registerCommand(new LeftCommand(commandManager));
  commandManager.registerCommand(new RightCommand(commandManager));
  commandManager.registerCommand(new ScanCommand(commandManager));
  commandManager.registerCommand(new ExitCommand(commandManager));
  commandManager.registerCommand(new ForbiddenHelpCommand(commandManager));
}
